import { Navigate } from 'react-router-dom';

import { Permission } from '@repo/types';
import { useHasPermission } from '@src/hooks/useHasPermission';
import { useGetUser } from '@src/api/useUser';
import { Loading } from '@repo/ui/components/Loading';

export interface ProtectedRouteProps {
  permissions: Permission[];
  redirectTo?: string;
  children: React.ReactNode;
  alsoAllowIf?: boolean;
}

export const ProtectedRoute = ({
  permissions,
  redirectTo,
  children,
  alsoAllowIf,
}: ProtectedRouteProps) => {
  const { hasOnePermission } = useHasPermission();
  const { isLoading, isFetching } = useGetUser();
  const isAllowed = hasOnePermission(permissions) || alsoAllowIf;

  if (isLoading || (!isAllowed && isFetching)) {
    return <Loading size="fullScreen" />;
  }
  if (!isAllowed) {
    return <Navigate to={redirectTo || '/unauthorized'} replace />;
  }
  return children;
};
